import React, {useState, useEffect} from 'react';
import {DialogTitle} from '@material-ui/core';
import {DialogContent} from '@material-ui/core';
import {Formik} from "formik";
import {TextField, Dialog} from "../../styles/config";
import validator from './validator';
import CircularIntegration from "../../widgets/CircularIntergration";
import {createResource, updateResource} from "../../utils/formik";
import Translate from "../../utils/utils";

const Edit = ({handleCreate, resource, initialValues, handleUpdate, onCloseModal, moduleName}) => {

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        setOpen(initialValues.id !== undefined);
    }, [initialValues]);


    const closeModal = () => {
        setOpen(false);
        onCloseModal();
    };

    const isCreatingResource = () => {
        return initialValues.id === undefined;
    };

    return (
        <div>
            <button className="btn btn-success btn-elevate kt-add-user__button  kt-login__btn-primary"
                    onClick={() => setOpen(true)}>
                <Translate id="DIALOG.BUTTON.ADD.TITLE"/>
            </button>
            <Dialog onClose style={{backgroundColor: 'rgba(43, 32, 43, 0.8)'}} onClose={closeModal}
                    aria-labelledby="customized-dialog-title" open={open}>
                <DialogTitle id="customized-dialog-title" onClose={closeModal}>
                    <div className="title__user-wrapper">
                        <div className="title__user-action">
                            <CircularIntegration done={!loading} load={loading}/>
                        </div>
                        <div className="title__user-title">
                            <h3>
                                {isCreatingResource() ? <Translate id={"DIALOG.BUTTON.ADD.TITLE"}/> :
                                    <Translate id={"TABLE.ACTIONS.EDIT"}/>} <Translate id="DIALOG.FORM.LANGUAGE"/>
                            </h3>
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent dividers>
                    <Formik
                        initialValues={initialValues}

                        onSubmit={(payload, methods) => isCreatingResource() ? createResource(payload, methods, resource, setLoading, handleCreate) : updateResource(payload, methods, resource, setLoading, handleUpdate)}
                        enableReinitialize={!isCreatingResource()}
                    >
                        {({
                              values,
                              status,
                              errors,
                              touched,
                              handleChange,
                              handleBlur,
                              handleSubmit,
                              isSubmitting,
                          }) => (
                            <form onSubmit={handleSubmit} className="kt-form">
                                {status && (
                                    <div role="alert" className="alert alert-danger">
                                        <div className="alert-text">{status}</div>
                                    </div>
                                )}

                                <TextField
                                    margin="dense"
                                    variant="outlined"
                                    label="Name"
                                    type="text" autoComplete="off"
                                    fullWidth={true}
                                    name="name"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values?.name}
                                    helpertext={touched?.name && errors?.name}
                                    error={Boolean(touched?.name && errors?.name)}
                                />
                                <div className="kt-add-user__actions">
                                    <button
                                        type="submit"
                                        disabled={isSubmitting || Object.is(initialValues, values)}
                                        className={`btn btn-success btn-elevate kt-add-user__save  kt-login__btn-primary`}

                                    >
                                        {isCreatingResource() ? <Translate id={"DIALOG.FORM.BUTTON.SAVE"}/> :
                                            <Translate id={"DIALOG.FORM.BUTTON.UPDATE"}/>}
                                    </button>
                                    <i
                                        onClick={closeModal}
                                        className={`btn btn-success btn-elevate kt-add-user__button  kt-login__btn-primary`}
                                    >
                                        <Translate id={"DIALOG.FORM.BUTTON.CLOSE"}/>
                                    </i>
                                </div>
                            </form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default Edit;
